import { Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
  selector: "flow-button",
  templateUrl: "./flow-button.component.html",
  styleUrl: "./flow-button.component.scss",
  standalone: false,
})
export class FlowButtonComponent {
  @Input() label: string = ""
  @Input() icon: string = ""
  @Input() disabled: boolean = false
  @Input() type: "primary" | "secondary" | "tertiary" | "destructive" = "primary"
  @Input() width: string = "fit-content"
  @Input() iconLeft: boolean = true
  @Input() doubleIcon: boolean = false
  @Input() size: "tiny" | "small" | "medium" | "large" = "medium"
  @Input() loading: boolean = false
  @Input() backgroundColor: string = ""

  getWidth(): string {
    if (!!this.label) return this.width
    else if (this.size === "tiny") return "32px"
    else if (this.size === "small") return "40px"
    else if (this.size === "medium") return "48px"
    else return "56px"
  }
  getHeight(): string {
    if (this.size === "tiny") return "32px"
    else if (this.size === "small") return "40px"
    else if (this.size === "medium") return "48px"
    else return "56px"
  }

  onClick(event: MouseEvent) {
    if (this.loading) return
    const button = event.currentTarget as HTMLElement

    button.classList.remove("ripple")
    void button.offsetWidth
    button.classList.add("ripple")

    button.addEventListener(
      "animationend",
      () => {
        button.classList.remove("ripple")
      },
      { once: true },
    )
  }
}
